// Alle danske UI-tekster til de nye sider (fase 2, trin B). Ordlyd følger
// prototypen i docs/prototype/index.html.
const texts = {
  nav: {
    home: 'Hjem',
    game: 'Spil',
    clubs: 'Klubber',
    stats: 'Statistik',
    me: 'Mig'
  },
  login: {
    title: 'Log ind',
    intro: 'Skriv din e-mail, så sender vi en kode. Ingen adgangskode.',
    emailPlaceholder: 'din@mail.dk',
    sendCode: 'Send kode',
    sending: 'Sender…',
    or: 'eller',
    google: 'Log ind med Google',
    passkey: 'Log ind med Face ID',
    protectedBy: 'Beskyttet af Cloudflare Turnstile',
    backToStart: '← Tilbage til forsiden',
    checkMail: 'Tjek din mail',
    codeSentTo: 'Vi har sendt en 6-cifret kode til',
    namePrompt: 'Dit navn (ny bruger)',
    namePlaceholder: 'Fornavn',
    logIn: 'Log ind',
    loggingIn: 'Logger ind…',
    createAndLogIn: 'Opret og log ind',
    resendHint: 'Ingen mail? Tjek spam, eller send en ny kode',
    turnstileWait: 'Vent et øjeblik på robot-tjekket og prøv igen',
    invalidEmail: 'Skriv en gyldig e-mail',
    missingName: 'Skriv dit navn',
    genericSendError: 'Kunne ikke sende koden',
    genericLoginError: 'Login fejlede'
  },
  authCallback: {
    loggingIn: 'Logger ind…'
  },
  home: {
    greeting: (name: string) => `Godaften, ${name}`,
    round: (n: number) => `Runde ${n}`,
    leading: (name: string, points: string) => `${name} fører med ${points}`,
    noRoundsYet: 'Ingen runder endnu',
    noActiveGame: 'Ingen aktive spil',
    noActiveGameHint: 'Start en spilaften med knappen nedenfor.',
    continue: 'Fortsæt',
    inProgress: 'I gang',
    seeAll: (n: number) => `Se alle (${n}) →`,
    seasonHeading: (year: number) => `Sæson ${year}`,
    clubLink: 'Klub →',
    noClubTitle: 'Opret en klub',
    noClubHint: 'Klubben samler jeres sæson og gør det nemt at invitere spillere.',
    noClub: 'Uden klub',
    latest: 'Seneste afsluttede',
    allGamesLink: 'Alle spil →',
    yourPoints: (points: string) => `du ${points}`,
    yearHeading: 'Dit år',
    yearSummary: (year: number, games: number, totalPoints: string, winRate: string) =>
      `${year}: ${games} aftener · ${totalPoints} point · ${winRate} gået hjem`,
    newGame: 'Ny spilaften'
  },
  me: {
    bigText: 'Stor tekst',
    bigTextHint: 'Tal og knapper 22 % større',
    lightTheme: 'Lyst tema',
    lightThemeHint: 'Til dagslys. Mørkt er standard',
    sound: 'Lyd',
    soundHint: 'Et lille dunk, når runden gemmes',
    haptic: 'Vibration',
    hapticHint: 'Når runden gemmes (Android)',
    createPasskey: 'Opret passkey på denne telefon',
    passkeyCreated: 'Passkey oprettet på denne telefon',
    removePasskey: 'Fjern',
    rulesLink: 'Pointsystem og regler',
    clubsLink: 'Klubber',
    adminLink: 'Admin',
    account: 'Konto',
    namePlaceholder: 'Navn',
    emailPlaceholder: 'E-mail',
    save: 'Gem',
    logOut: 'Log ud',
    deleteAccount: 'Slet konto',
    deleteAccountConfirm: 'Er du sikker? Dette kan ikke fortrydes.',
    deleteAccountConfirmButton: 'Ja, slet min konto',
    cancel: 'Annuller',
    guestTitle: 'Tilføj e-mail',
    guestHint: 'Knyt en e-mail til kontoen, så du kan logge ind på en anden telefon. Dine spil følger med.',
    attachEmailLabel: 'Knyt e-mail til kontoen',
    sendCode: 'Send kode',
    sending: 'Sender…',
    codePlaceholder: 'Kode',
    attachEmailButton: 'Knyt e-mail',
    attaching: 'Knytter…',
    emailAttached: 'E-mail knyttet til kontoen',
    couldNotSendCode: 'Kunne ikke sende koden',
    couldNotAttachEmail: 'Kunne ikke knytte e-mailen'
  },
  stats: {
    title: 'Statistik',
    comingTitle: 'Kommer i fase 3',
    comingHint: 'Meldinger og succesrate, makker-matrix, sæsonstilling for klubben, rekorder og delbart resultat.'
  },
  games: {
    title: 'Spil',
    newGame: 'Ny spilaften',
    activeTitle: 'Aktive',
    finishedTitle: 'Afsluttede',
    noActive: 'Ingen aktive spil',
    noActiveHint: 'Start en spilaften med knappen ovenfor.',
    noFinished: 'Ingen afsluttede spil endnu',
    players: (n: number) => `${n} spillere`,
    winner: (name: string) => `${name} vandt`,
    noClub: 'Uden klub'
  },
  newGame: {
    title: 'Ny spilaften',
    defaultName: (date: string) => `Torsdagswhist ${date}`,
    playersHeading: (n: number) => `Spillere (4–6) · ${n} valgt`,
    you: 'dig',
    inviteTitle: 'Inviter med QR eller link',
    inviteHint: 'Spillere uden konto scanner og skriver et navn. De kan oprette konto bagefter.',
    copyLink: 'Kopiér link',
    noClubTitle: 'Opret først en klub',
    noClubHint: 'Spillere vælges fra en klub. Opret klubben, og kom herefter tilbage.',
    noClubLink: 'Gå til klubber →',
    start: 'Start spillet',
    pickCountHint: 'Vælg mellem 4 og 6 spillere',
    maxPlayers: 'Højst 6 spillere',
    genericStartError: 'Kunne ikke starte spillet'
  },
  landing: {
    brand: 'WhistBuddy',
    logIn: 'Log ind',
    headline: 'Whistaftenen uden regnestykker.',
    intro:
      'Meld, spil, tast stik. WhistBuddy regner point for alle ved bordet, holder styr på hvem der giver, og husker hele sæsonen.',
    start: 'Start en spilaften',
    seeRules: 'Se pointsystemet',
    feature1Title: 'Alle meldinger',
    feature1Text: 'Almindelige, halve, gode, vip, sol og bordlægger. Med makker eller alene.',
    feature2Title: 'Alle ser stillingen',
    feature2Text: 'Hver spiller følger med på sin egen telefon.',
    feature3Title: 'Hele sæsonen',
    feature3Text: 'Hvem fører i klubben? Hvem tør melde 10 gode?',
    footerFree: 'Gratis at bruge',
    footerBy: 'Lavet af Brian Kidmose Andersen',
    footerPrivacy: 'Privatliv og vilkår'
  },
  rules: {
    title: 'Pointsystem',
    trumpOther: 'Anden trumf',
    trumpClubs: 'Klør (×2)',
    calculatorLabel: 'Pointberegner',
    solo: 'Solo',
    won: 'Vundet',
    lost: 'Tabt',
    tricksTaken: 'stik taget',
    bidderAndPartner: 'Melder og makker',
    opponents: 'modstandere',
    each: 'hver',
    soloBidder: 'Melder',
    soloOthers: 'de tre andre',
    explanationTitle: 'Sådan regnes der',
    explanationP1:
      'Værdien af en melding fordobles for hvert stik over 7: 7 alm. = 1, 8 = 2, 9 = 4, 10 = 8, 11 = 16, 12 = 32, 13 = 64. Halve, gode og 1. vip er det dobbelte, 2. vip fire gange, 3. vip otte gange. Gode spilles altid i klør. Halve og vip i klør tæller dobbelt, så 1. vip i klør giver det samme som 2. vip. Hvert ekstra stik giver én værdi mere, hvert manglende stik koster én værdi. Sol giver 24, ren sol 48, ren bordlægger 192, dobbelt bordlægger 384, og de tre andre deler det modsatte.',
    explanationP2:
      'Med 5 eller 6 spillere sidder 1 eller 2 over på skift og får 0 i runden. Melder man med sig selv som makker, får man tre gange værdien, og de tre andre hver minus én.',
    tablesTitle: 'Pointtabeller',
    tablesHint: 'De fulde tabeller for hver meldingstype, opslået på antal stik.',
    tablesLoading: 'Henter pointtabeller…',
    tablesError: 'Kunne ikke hente pointtabeller',
    tablesEmpty: 'Ingen tabeller fundet'
  },
  privacy: {
    title: 'Privatliv',
    dataStoredTitle: 'Hvad gemmer vi',
    dataStoredText:
      'Dit navn, din e-mail, din spilhistorik og de offentlige nøgler til dine passkeys. Ikke mere end det.',
    whereTitle: 'Hvor ligger det',
    whereText: 'Hos Cloudflare, i EU. Vi bruger ikke tracking eller reklamer.',
    emailTitle: 'E-mail',
    emailText: 'Login-koder og andre beskeder sendes via Resend.',
    deleteTitle: 'Slet dine data',
    deleteText: 'Gå til Mig → Slet konto. Det fjerner din konto og din spilhistorik permanent.',
    contactTitle: 'Kontakt',
    contactText: 'Spørgsmål? Skriv til hej@whistbuddy.dk.',
    termsTitle: 'Vilkår',
    termsText:
      'WhistBuddy er en gratis tjeneste uden garanti. Brug den, som den er, og vær rar ved de andre ved bordet.'
  },
  game: {
    loading: 'Indlæser spil…',
    notFound: 'Spillet kunne ikke findes',
    backToHome: '← Tilbage til hjem',
    show: 'Vis',
    history: 'Historik',
    round: (n: number) => `Runde ${n}`,
    editRound: (n: number) => `Ret runde ${n}`,
    dealerGives: (name: string) => `${name} giver`,
    curveLabel: 'Pointkurve for aftenen',
    sittingOut: 'sidder over',
    sittingOutNames: (names: string[]) => `${names.join(' og ')} sidder over`,
    dealerBadge: '♦ giver',
    bidderLabel: 'Melder',
    soloLabel: 'Solo',
    partnerLabel: 'Makker',
    selfLabel: 'Selv',
    selfNote: ' (selvmakker)',
    tricksTakenLabel: 'stik taget',
    fewerTricks: 'Færre stik',
    moreTricks: 'Flere stik',
    choosePartner: 'Vælg makker',
    others: 'andre',
    won: 'Vundet',
    lost: 'Tabt',
    saveRound: 'Gem runde',
    updateRound: 'Opdater runde',
    cancel: 'Annuller',
    undoLast: 'Fortryd sidste',
    finishGame: 'Afslut spillet',
    confirmUndo: 'Er du sikker på at du vil fortryde den sidste runde?',
    confirmUndoButton: 'Ja, fortryd',
    confirmFinish: 'Er du sikker på at du vil afslutte spillet?',
    confirmFinishButton: 'Ja, afslut',
    deleteGame: 'Slet spillet',
    deleteConfirm: 'Slet spillet og alle runder?',
    deleteConfirmYes: 'Ja',
    deleteConfirmNo: 'Nej',
    deleteHint: 'Tast mindst én runde for at afslutte, eller slet spillet.',
    gameDeleted: 'Spillet er slettet',
    couldNotDelete: 'Kunne ikke slette spillet',
    completed: 'Afsluttet',
    finalStanding: 'Slutstilling',
    historyHint: (n: number) => `${n} runde${n === 1 ? '' : 'r'}. Tryk på en runde for at rette den.`,
    tricksSuffix: 'stik',
    editRoundButton: 'Ret',
    roundPointsLabel: 'Runde',
    roundTotalAfter: 'Total',
    noRoundsYet: 'Ingen runder endnu.',
    lastRound: (text: string) => `Sidste runde: ${text}`,
    boardHint: 'Til tablet eller tv ved bordet. Opdaterer sig selv.',
    roundSaved: (n: number) => `Runde ${n} gemt`,
    roundUpdated: 'Runde opdateret',
    couldNotLoad: 'Kunne ikke hente spillet',
    couldNotSaveRound: 'Kunne ikke gemme runden',
    couldNotUpdateRound: 'Kunne ikke opdatere runden',
    couldNotUndo: 'Kunne ikke fortryde runden',
    couldNotFinish: 'Kunne ikke afslutte spillet',
    noActiveGame: 'Ingen aktive spil',
    noActiveGameHint: 'Start en spilaften fra Hjem.'
  },
  clubs: {
    title: 'Klubber',
    members: (n: number) => `${n} medlemmer`,
    roleOwner: 'ejer',
    roleMember: 'medlem',
    createTitle: '+ Opret klub',
    namePlaceholder: 'Klubbens navn',
    createButton: 'Opret',
    creating: 'Opretter…',
    emptyTitle: 'Ingen klubber endnu',
    emptyHint:
      'En klub er en fast gruppe I spiller whist i. Inviter med et link eller en QR-kode, og følg sæsonstillingen sammen.',
    missingName: 'Skriv et navn',
    genericCreateError: 'Kunne ikke oprette klubben'
  },
  club: {
    loading: 'Indlæser klub…',
    inviteTitle: 'Inviter til klubben',
    inviteHint: 'Del linket, eller lad dem scanne QR-koden.',
    newLink: 'Nyt link',
    newLinkConfirm: 'Det gamle link stopper med at virke. Fortsæt?',
    newLinkConfirmButton: 'Ja, lav nyt link',
    season: (year: number) => `Sæsonstilling ${year}`,
    membersTitle: 'Medlemmer',
    guestChip: 'uden e-mail',
    remove: 'Fjern',
    removeConfirm: (name: string) => `Fjern ${name} fra klubben?`,
    removeConfirmButton: 'Ja, fjern',
    rename: 'Omdøb',
    renameSave: 'Gem navn',
    leave: 'Forlad klubben',
    leaveConfirm: 'Er du sikker på at du vil forlade klubben?',
    leaveConfirmButton: 'Ja, forlad',
    cancel: 'Annuller',
    games: (n: number) => `${n} spil`,
    genericError: 'Noget gik galt',
    couldNotLeave: 'Kunne ikke forlade klubben',
    couldNotRemove: 'Kunne ikke fjerne medlemmet',
    couldNotRename: 'Kunne ikke omdøbe klubben',
    couldNotRotate: 'Kunne ikke lave nyt link',
    inviteEmailTitle: 'Inviter via e-mail',
    inviteEmailPlaceholder: 'E-mail',
    inviteEmailButton: 'Send invitation',
    inviteSending: 'Sender…',
    inviteSent: 'Invitation sendt',
    inviteAlreadyMember: 'Er allerede medlem',
    inviteError: 'Kunne ikke sende invitationen',
    candidatesTitle: 'Tilføj fra dine andre klubber',
    addMember: 'Tilføj medlem',
    memberAdded: 'Medlem tilføjet',
    couldNotAddMember: 'Kunne ikke tilføje medlemmet',
    ownerTitle: 'Ejer',
    transferTitle: 'Overdrag ejerskab',
    transferButton: 'Overdrag',
    transferConfirm: (name: string) => `${name} bliver ny ejer af klubben. Fortsæt?`,
    transferConfirmButton: 'Ja, overdrag',
    transferDone: 'Ejerskabet er overdraget',
    couldNotTransfer: 'Kunne ikke overdrage ejerskabet',
    deleteTitle: 'Slet klub',
    deleteButton: 'Slet klub',
    deleteClubConfirm: (name: string) => `Slet ${name}? Medlemskaberne fjernes. Spillene bevares uden klub.`,
    deleteClubConfirmButton: 'Ja, slet klub',
    deleteDone: 'Klubben er slettet',
    couldNotDeleteClub: 'Kunne ikke slette klubben'
  },
  join: {
    loading: 'Henter invitation…',
    notFoundTitle: 'Invitationen findes ikke eller er udløbet',
    invitedTo: (clubName: string) => `Du er inviteret til ${clubName}`,
    members: (n: number) => `${n} medlemmer`,
    joinButton: 'Bliv medlem',
    joining: 'Deltager…',
    namePlaceholder: 'Dit navn',
    createAndJoin: 'Opret konto og deltag',
    noPasswordHint:
      'Ingen adgangskode. Du kan tilføje din e-mail senere under Mig, så du kan logge ind på andre telefoner.',
    haveAccount: 'Har du allerede en konto? Log ind',
    missingName: 'Skriv dit navn',
    genericJoinError: 'Kunne ikke deltage i klubben'
  },
  admin: {
    title: 'Admin',
    usersTile: 'Brugere',
    gamesTile: 'Spil',
    roundsTile: 'Runder',
    visitsTile: 'Besøg',
    searchPlaceholder: 'Søg efter navn eller e-mail',
    nameHeader: 'Navn',
    emailHeader: 'E-mail',
    createdHeader: 'Oprettet',
    delete: 'Slet',
    deleteConfirm: (name: string) => `Slet ${name}? Dette kan ikke fortrydes.`,
    deleteConfirmButton: 'Ja, slet',
    cancel: 'Annuller',
    empty: 'Ingen brugere fundet',
    prev: 'Forrige',
    next: 'Næste',
    page: (page: number, totalPages: number) => `Side ${page} af ${totalPages}`
  },
  toasts: {
    passkeyCreated: 'Passkey oprettet',
    passkeyRemoved: 'Passkey fjernet',
    accountSaved: 'Konto opdateret',
    linkCopied: 'Link kopieret'
  },
  pwa: {
    offlineChip: 'Offline · viser sidst kendte stilling',
    savedOffline: 'Ingen net. Runden er gemt her og sendes, når nettet er tilbage',
    updateAvailable: 'Ny version hentet, genindlæs',
    reload: 'Genindlæs',
    pendingChip: 'venter på net'
  },
  errors: {
    generic: 'Noget gik galt. Prøv igen.',
    couldNotUpdateAccount: 'Kunne ikke opdatere konto',
    couldNotDeleteAccount: 'Kunne ikke slette konto',
    couldNotCreatePasskey: 'Kunne ikke oprette passkey',
    couldNotRemovePasskey: 'Kunne ikke fjerne passkey'
  }
}

export default texts
